import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
@Component({
  selector: 'shared-dropdown-input',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, ReactiveFormsModule, TranslocoModule],
  templateUrl: './dropdown-input.component.html',
  styleUrl: './dropdown-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DropdownInputComponent),
    multi: true
  }]
})

export class DropdownInputComponent implements OnChanges{
  @Input() currentLang = 'en';
  @Input() value = null;
  @Input() options: any[] = [];
  @Input() placeholder = 'Select...';
  @Input() inputType: 'dropdown' | 'multiSelect' | 'dropdown_country' | 'countryInput' | 'disableOptionInputSearch' | 'inputSearch' = 'dropdown';
  @Input() bindLabel = '';
  @Input() bindValue = '';
  @Input() disableOpenOption: any = false;
  @Input() disabled = false;
  @Input() isalphaOnly=false;
  @Input() maxlengthValidations=false;
  errorMsg:any;
  maxAllowedLength = 150;
  private internalValue: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] || changes['value']) {
      this.trySetValue();
    }
  }

  @ViewChild(NgSelectComponent) ngSelect!: NgSelectComponent;

  ngAfterViewInit() {
    const inputEl = this.ngSelect.searchInput?.nativeElement;
    if (inputEl && this.isalphaOnly) {
      inputEl.addEventListener('keypress', (e: KeyboardEvent) => {
        const currentValue = inputEl.value;
        const newLength = currentValue.length + 1;

        if (!/[a-zA-Z ]/.test(e.key)) {
          e.preventDefault();
        }

        if (this.maxlengthValidations && newLength > this.maxAllowedLength+1) {
          e.preventDefault();
          this.errorMsg = `maximumCharacterAllowed`;
          return;
        } else {
          this.errorMsg = null;
        }
      });
  
      // Optional: clear error if user deletes text
      inputEl.addEventListener('input', () => {
        if (inputEl.value.length <= this.maxAllowedLength) {
          this.errorMsg = null;
        }
      });

      
    }
  }

  onChange = (value: any) => {
    console.log(value);

  };
  onTouched = () => { };

  writeValue(value: any): void {
    this.internalValue = value;
    this.trySetValue(); // Tries to apply the value only if options are available
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleChange(value: any): void {
    if(this.maxlengthValidations) this.errorMsg = null;
    if (this.disableOpenOption) this.dropDownMonitor = false;
    this.value = value;
    this.onChange(value);
  }

  addTagFn(name: any) {
    return { name: name, tag: true };
  }

  addStateTag(name: string) {
    const body =
    {
      code: name,
      nameEn: name
    }
    this.options.push(body);
    return body;
  }

  dropDownMonitor: any = false;
  onSearch(searchData: any) {

    const alphaOnly = searchData.term.replace(/[^a-zA-Z ]/g, '');
    if(this.isalphaOnly && searchData.term !== alphaOnly){
      return;
      event?.preventDefault();
    }
    if (searchData.term)
      this.dropDownMonitor = true;
    else
      this.dropDownMonitor = false;
  }

  trySetValue(): void {
    if (!this.options || this.options.length === 0) return;

    const found = this.bindValue
      ? this.options.find(option => option[this.bindValue] === this.internalValue)
      : this.options.find(option => option === this.internalValue);

    if (found) {
      this.value = this.internalValue;
    }
  }

  customSearchFn = (term: string, item: any) => {
    if (!term) return true;
    const searchTerm = term.toLowerCase();
    const name = this.currentLang === 'en'
      ? item.nameEn?.toLowerCase()
      : item.nameAr?.toLowerCase();
    return name?.startsWith(searchTerm);
  };

}
